<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label"><span class="mr-2">{{ function_name }} </span></div>
      <!-- RWD START: filter row stacks below lg, original layout at lg+ -->
      <div class="row">
        <div class="col-12 col-lg">
          <div class="row">
            <div class="col-12 col-lg-4">
              <div class="label mt-2">My Status</div>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="sub-label"></div>
                  <gtc-multi-select v-model="my_status" key-field="value" text-field="text"
                                    :options="my_status_options" select-class="w-100" @blur="focusButton"
                                    @change="onChange"></gtc-multi-select>
                </div>
              </div>
              <div class="label mt-2">Status</div>
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="sub-label">Ticket Status:</div>
                  <gtc-multi-select v-model="ticket_status" key-field="value" text-field="text" @blur="focusButton"
                                    :options="ticket_status_options" select-class="w-100"></gtc-multi-select>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="sub-label">NRE Status:</div>
                  <gtc-multi-select v-model="NRE_status" key-field="value" text-field="text" @blur="focusButton"
                                    :options="NRE_status_options" select-class="w-100"></gtc-multi-select>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg">
              <div class="label mt-2">Owner</div>
              <div class="row">
                <div class="col-6 col-md-3">
                  <div class="sub-label">GRO Site:</div>
                  <b-form-select v-model="GRO" :options="GRO_options" label="GRO Site:" @change="onChangeGRO(); focusButton();" @select="focusButton"></b-form-select>
                </div>
                <div class="col-6 col-md-3">
                  <div class="sub-label">GRO Owner (L1):</div>
                  <div v-if="GROOwnerList.length == 0">
                    <b-form-input v-model="GRO_owner" placeholder="" label="GRO Owner:" trim @blur="focusButton"></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GRO_owner" :options="GROOwnerList" label="GRO Owner:" @change="focusButton"></b-form-select>
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <div class="sub-label">GTC Owner (L2):</div>
                  <div v-if="GTCOwnerList.length == 0">
                    <b-form-input v-model="GTC_owner" placeholder="" label="GTC Owner:" trim @blur="focusButton"></b-form-input>
                  </div>
                  <div v-else>
                    <b-form-select v-model="GTC_owner" :options="GTCOwnerList" label="GTC Owner:" @change="focusButton"></b-form-select>
                  </div>
                </div>
                <div class="d-none d-md-block col-md-3"><div class="sub-label"></div></div>
              </div>
              <div class="label mt-2">Search</div>
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-3">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="model" key-field="value" text-field="text"
                                    :options="model_options" select-class="w-100" class="w-100" @blur="focusButton"></gtc-multi-select>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="sub-label">NRE Create Date:</div>
                  <div class="d-flex flex-wrap flex-sm-nowrap">
                    <input type="text" class="form-control" v-model="date_from" v-datepicker:to="date_to" @blur="focusButton" />
                    <span class="font-weight-bold align-self-center mx-1 d-none d-sm-inline">～</span>
                    <input type="text" class="form-control mt-1 mt-sm-0" v-model="date_to" v-datepicker:from="date_from" @blur="focusButton" />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                  <div class="sub-label">Keywords:</div>
                  <b-form-input v-model="keywords"
                                placeholder=""
                                label="Keywords:" @blur="focusButton"
                                trim>
                  </b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="actionColClass" :style="actionColStyle">
          <b-button @click="search()" variant="primary" ref="focusButton" @keyup.enter.prevent="search()" autofocus :block="isSmDown">Search</b-button>
          <b-button @click="resetFilterCondition()" variant="btn btn-outline-primary" @blur="focusButton" :block="isSmDown" class="mt-1 mt-lg-0">Reset</b-button>
        </div>
      </div>
      <!-- RWD END: filter row -->
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex align-items-center flex-wrap">
        <div class="h5 font-weight-bold mb-0">{{ rows }} Results</div>
        <!-- RWD START: scroll hint shown only on small screens -->
        <small class="text-muted ml-2 d-inline d-lg-none">← swipe to view all stages →</small>
        <!-- RWD END: scroll hint -->
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(ftie_ticket.ftie_id)="data">
            <!-- <gtc-ftie :ftieId="data.item.ftie_ticket.ftie_id" />  -->
            <gtc-link-to-ftie-dashboard :ftieId="data.item.ftie_ticket.ftie_id" />
          </template>

          <template #cell(sales_force_opty)="data">
            <gtc-opportunity :opportunityId="data.item.sales_force_opty_id"
                             :opportunityName="data.item.sales_force_opty" />
          </template>

          <template #cell(nre_status)="data">
            <!-- NEW: show reason detail -->
            <div v-if="checkStatusForReasonDetail(data) && data.item.reject_reason && data.item.reject_reason !== 'None'">
              <span>
                {{data.item.nre_status}}
              </span>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" @click="showReasonDetailModal(data)" v-b-tooltip.hover.right :title="tooltipReason(data)"></button>
              <b-modal ref="ReasonDetailModal" centered :title="'Reason'" button-size="sm" hide-footer>
                <div class="d-block">
                  <p>{{ reason_text }}</p>
                </div>
              </b-modal>
            </div>

            <div v-else>
              <span>{{ data.item.nre_status }}</span>
            </div>
            <!-- end of region-->
          </template>

          <template #cell(stage)="data">
            <div v-if="data.item.ticket_type === 'ETO Sector SKU'">
              <span class="pr-1" style="color: #f77530">ETO Sector SKU : </span>
              <span class="pr-1">{{ data.item.nre_model }} </span>
              <!-- FLAG START -->
              <span v-if="eQuoteAvailable(data.item.signing_stages)">
                <b-badge href="#" :variant="isExpiredInEquote(data.item) ? 'secondary' : 'success'">{{ isExpiredInEquote(data.item) ? 'Expired in eQuote' : 'Active in eQuote' }}</b-badge>
              </span>
              <!-- FLAG END -->
            </div>
            <div v-else>
              <span class="pr-1">{{ data.item.nre_model }} - </span>
              <span class="font-weight-bold">{{data.item.sku_id}}</span>
              <!-- FLAG START -->
              <span v-if="eQuoteAvailable(data.item.signing_stages)">
                <b-badge href="#" :variant="isExpiredInEquote(data.item) ? 'secondary' : 'success'">{{ isExpiredInEquote(data.item) ? 'Expired in eQuote' : 'Active in eQuote' }}</b-badge>
              </span>
              <!-- FLAG END -->
              <span v-if="data.item.confirm_flag==='Y' && (data.item.gtc_owner==login_user_name || adminMemberSettingAccess())">
                <b-badge href="#" variant="primary">Tracked NRE</b-badge>
                <button type="button"
                        class="btn btn-sm btn-link p-0 "
                        @click.prevent="preConfirm(data.item, 'N')">
                  Untrack
                </button>
              </span>
              <span v-if="data.item.confirm_flag !== 'Y' && (data.item.gtc_owner==login_user_name || adminMemberSettingAccess())">
                <button type="button" v-if="data.item.gtc_owner==login_user_name || adminMemberSettingAccess()"
                        class="btn btn-sm btn-link p-0 "
                        @click.prevent="preConfirm(data.item, 'Y')">
                  Track
                </button>
              </span>
            </div>

            <!--             <div v-else>
            <b-badge href="#" variant="secondary">Unavailable in eQuote</b-badge>
          </div>-->

            <div class="row mx-0 flex-nowrap sign-off-diagram" :class="[data.item.nre_status]"
                 style="min-width: 58rem; width: calc(100% - 14px);">
              <template v-for="(stage, stageIndex) in data.item.signing_stages">

                <div class="col p-0 stage"
                     :title="tooltipTitle(data, stageIndex)">
                  <component :is="linkEnable(data, stageIndex) ? 'a': 'span'"
                             :href="safeUrl(linkEnable(data, stageIndex) ? getLink(data, stageIndex):'')"
                             target="_blank">
                    <div class="row px-1 align-items-center justify-content-center diagram">
                      <div class="col" :class="{'on': isCompleted(data.item.signing_stages, stageIndex, stageIndex - 1)}"></div>
                      <div class="col-auto" :class="[getStatusName(data.item.signing_stages, stageIndex)]"></div>
                      <div class="col" :class="{'on': isCompleted(data.item.signing_stages, stageIndex, stageIndex + 1)}"></div>
                    </div>
                    <div class="text-center text-nowrap px-2 text-gray-850 submitter">
                      {{ _.get(stage, 'submitted_by.submitter_name', '') | firstNameOnly }}
                    </div>
                    <div class="small text-gray-570 text-center text-nowrap update-date" v-if="stage.submitted_by.submitter_name!='SKIP'">
                      {{ _.get(stage, 'last_update_date', '') | dateFormat }}
                    </div>
                  </component>
                </div>
              </template>
            </div>
          </template>
        </b-table>
      </div>
      <div class="d-flex pr-3">
        <div class="ml-auto">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>
      <!-- RWD START: footer row wraps + centers on mobile -->
      <div class="row mx-n1 align-items-center pr-3 flex-wrap justify-content-center justify-content-lg-end">
        <div class="px-1 col-auto ml-lg-auto small">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="px-1 col-auto small">rows per page</div>
      </div>
      <!-- RWD END: footer row -->
    </div>

    <!--#endregion -- Body ---->
    <b-modal centered ok-title="Yes" @ok="confirmTracking"
             cancel-title="Cancel"
             ok-variant="primary"
             title-class="primary"
             ref="preConfirmModal" title="NRE Scope Management"
             button-size="sm">
      <div v-if="confirmNre.confirm_flag === 'N'">
        <p>Are you sure you want to <b>Untrack NRE</b> for this project?</p>
        <small class="text-muted">Note: This NRE and relative cost/price info will no longer be counted in Project Tracking.</small>
      </div>

      <div v-if="confirmNre.confirm_flag === 'Y'">
        <p>Are you sure you want to <b>Track NRE</b>?</p>
        <p class="text-danger small">This record will be marked as the <b>Tracked NRE</b> and active in project requirement.</p>
      </div>

    </b-modal>

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'dashboard',
    data() {
      return {
        function_name: 'NRE Process Tracking',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [{ value: '', text: 'ALL' }],
        GRO: '',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        model_options: [],
        model: '',
        etoLoadingCnt: 0,

        my_status_options: [{ value: 'InProgress', text: 'In Progress' }, { value: 'Oncoming', text: 'Oncoming' }],
        my_status: '',

        NRE_status_options: [],
        NRE_status: [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }],

        ticket_status_options: [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],

        reason_text: null,

        already_first_search_flag: false,
        fields: [
          { key: 'nre_id', label: 'ETO NRE', thClass: 'align-middle', sortable: true },
          { key: 'ftie_ticket.ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true },
          { key: 'account', label: 'Account Name', thClass: 'align-middle', sortable: true },
          { key: 'sales_force_opty', label: 'Salesforce Opportunity', thClass: 'align-middle', sortable: true },
          { key: 'nre_status', label: 'NRE Status', thClass: 'align-middle', sortable: true },
          {
            key: 'stage', label: 'Sign-off Status', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem' },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.sku_id;
            }
          }
        ],
        searchedData: [],
        serachByNreId: null,
        GRO_owner: '',
        GTC_owner: '',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        nreTotalCount: '',
        confirmNre: {ftie_id: '' ,nre_id: '', request_form_id: '', confirm_flag: ''},
        stageTip: ['ESPM Submitted', 'ES PM Head Review', 'HQ Sales Review', 'SA Head Review', 'RSM Confirmation',
          'Sales Director/Manager Confirmation', 'GRO Head Confirmation', 'SA Head Confirmation', 'HQ Sales Confirmation', 'ES PM Project Kickoff'],

        urlHead: ['espm-submitted', 'espm-leader-review', 'hq-sales-review', 'sa-head-review', 'rsm-confirm',
          'sales-director-confirm', 'gro-head-confirm', 'sa-head-confirm', 'hq-sales-confirm', 'espm-kickoff'],

        // RWD: track viewport width (bootstrap lg breakpoint = 992)
        windowWidth: (typeof window !== 'undefined') ? window.innerWidth : 1280,
      }
    },
    created() {
      let self = this;

    },
    computed: {
      rows() {
        return this.nreTotalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      // RWD computed: below bootstrap lg breakpoint
      isSmDown() {
        return this.windowWidth < 992;
      },
      actionColClass() {
        return this.isSmDown ? 'col-12 mt-2' : 'col-auto align-self-end';
      },
      actionColStyle() {
        return this.isSmDown ? {} : { width: '11.5rem' };
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.etoLoadingCnt = 0;
      //console.log("this.$router.currentRoute = ");
      //console.log(this.$router.currentRoute);
      if (this.$route.params.nreId) {
        this.serachByNreId = this.$route.params.nreId
        this.ticket_status = [];
        this.NRE_status = [];
        this.date_from = '';
        this.date_to = '';
        console.log("this.serachByNreId = ");
        console.log(this.serachByNreId);
        this.search();
      }
      if (this.$route.params.keywords){
        this.keywords = this.$route.params.keywords;
        this.ticket_status = [];
        this.NRE_status = [];
        this.date_from = '';
        this.date_to = '';
        this.search();
      }
      // RWD: keep windowWidth in sync with viewport
      this._rwdResizeHandler = () => { this.windowWidth = window.innerWidth };
      window.addEventListener('resize', this._rwdResizeHandler);
    },
    beforeDestroy() {
      if (this._rwdResizeHandler) {
        window.removeEventListener('resize', this._rwdResizeHandler);
        this._rwdResizeHandler = null;
      }
    },
    methods: {
      checkStatusForReasonDetail(data) {
        let statusNames = ['ConditionalApproved', 'Cancel', 'Rejected', 'Reject', 'Deferred'];
        let nullContext = ['', 'nan', 'None'];
        let dataStatus = _.trim(_.get(data.item, 'nre_status', ''));
        let reason = _.trim(_.get(data.item, 'reject_reason', ''));
        let result = (_.indexOf(statusNames, dataStatus) > -1) && (_.indexOf(nullContext, reason) === -1);
        return result;
      },
      showReasonDetailModal(data) {
        this.reason_text = _.trim(_.get(data.item, 'reject_reason', ''));
        this.$refs['ReasonDetailModal'].show()
      },
      eQuoteAvailable(stages) {
        let self = this;
        let statusNames = ['Submitted', 'Completed', 'Deferred', 'Finished'];
        let aliveInEquoteResult = _.indexOf(statusNames, self.getStatusName(stages, 8)) > -1 || _.indexOf(statusNames, self.getStatusName(stages, 9)) > -1;
        console.log("aliveInEquoteResult:");
        console.log(aliveInEquoteResult);
        return aliveInEquoteResult;
        // data.item.signing_stages

      },
      getHqSalesConfirmBaseDate(eto) {
        const stage = _.get(eto, 'signing_stages[8]', null);
        if (!stage) return null;
        const dateStr = _.get(stage, 'confirm_date')
          || _.get(stage, 'approved_date')
          || _.get(stage, 'defer_date')
          || _.get(stage, 'last_update_date');
        if (!dateStr) return null;
        const d = new Date(dateStr);
        return isNaN(d.getTime()) ? null : d;
      },
      isExpiredInEquote(eto) {
        const base = this.getHqSalesConfirmBaseDate(eto);
        if (!base) return false;
        return Math.floor((Date.now() - base.getTime()) / 86400000) > 45;
      },
      isCompleted(stages, index1, index2) {
        let self = this;
        let statusNames = ['Submitted', 'Completed', 'ConditionalApproved', 'SKIP', 'Finished'];

        let result = _.indexOf(statusNames, self.getStatusName(stages, index1)) > -1 ||
          _.indexOf(statusNames, self.getStatusName(stages, index2)) > -1;

        if (!result && self.getStatusName(stages, index1) !== '' && self.getStatusName(stages, index2) !== '')
          result = true;

        return result;
      },
      getStatusName(stages, index) {
        let status = _.replace(_.get(stages[index], 'status_name', null), / /g, '');
        if (!_.isNil(status) && status.length > 0) {
          if (index + 1 === stages.length && status === 'Completed')
            return 'Finished';
          else
            return status;
        }
        else {
          let next = _.replace(_.get(stages[index + 1], 'status_name', null), / /g, '');
          if (!_.isNil(next) && next.length > 0) return 'Completed';
          return '';
        }
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },

      linkEnable(data, stage_index) {
        let self = this;
        let login_user_name = self.$session.get('user_name');
        let signing_stage = data.item.signing_stages[stage_index];
        let stages_for_gro_manager = ['SA Head Review', 'GRO RSM Review', 'GRO Sales Director', 'GRO GM Confirmation', 'GRO SA Head Confirmation'];
        let stages_for_rsm_manager = ['GRO RSM Review', 'GRO Sales Director', 'GRO GM Confirmation'];
        let stages_for_getac_sales_manager = ['HQ Sales Review', 'GTC Sales Conformation'];
        // CASE 1 - NRE Owner or Admin User
        if ((login_user_name === signing_stage.submitted_by.submitter_name || login_user_name === 'power')
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return') {
          return true;
        }
        //NEW: ALLOW Solution PM review the ticket
        if (data.item.ticket_type === 'ETO Sector SKU' && signing_stage.status_name !== null && signing_stage.status_name !== 'Return' && (login_user_name === 'alex.lee' || login_user_name === 'keman.lee')) {
          return true;
        }
        // NEW REQUEST: GUSA HQ Sals View Each Other's Tickets
        else if (_.indexOf(stages_for_getac_sales_manager, signing_stage.stage_name) > -1
          && data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1
          && data.item.nre_site === 'GUSA'
          && (self.userRoles !== null && _.indexOf(self.userRoles, 'HQ_Sales') > -1)
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return') {
          return true;
        }
        // NEW REQUEST: Sales Director could access to RSM Stage
        else if ('GRO RSM Review' === signing_stage.stage_name
          && data.item.signing_stages[5].submitted_by.submitter_name === login_user_name
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return') {
          return true;
        }

        // NEW REQUEST V2.3: ISR , ISR Head, and Ticket GRO Owner/SA Accees RSM Stage (GUSA)
        else if ('GRO RSM Review' === signing_stage.stage_name
          && (self.userRoles !== null && (login_user_name === data.item.gro_owner || _.indexOf(self.userRoles, 'ISR') > -1 || _.indexOf(self.userRoles, 'ISR_HEAD') > -1))
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return') {
          return true;
        }

        // NEW REQUEST V2.3: ISR Head, Ticket GRO Owner/SA Accees Sales Director Stage (GUSA)
        else if ('GRO Sales Director' === signing_stage.stage_name
          && (self.userRoles !== null && (login_user_name === data.item.gro_owner || _.indexOf(self.userRoles, 'ISR_HEAD') > -1))
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return') {
          return true;
        }

        // NEW REQUEST V3.0: HQ Sales Access SA Head Review, SA Head Confirm
        else if (_.indexOf(stages_for_gro_manager, signing_stage.stage_name) > -1
          && (self.userRoles !== null && _.indexOf(self.userRoles, 'HQ_Sales') > -1)
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)
          && signing_stage.status_name !== null
          && signing_stage.status_name !== 'Return'
          && data.item.participant_names !== null && Object.values(data.item.participant_names).includes(login_user_name)) {
          return true;
        }

        // gtc_owner -> ESPM STAGE
        else if (_.indexOf(['ES PM', 'Estimation ESPM Kickoff'], signing_stage.stage_name) > -1
          && signing_stage.status_name !== null
          && (data.item.gtc_owner === login_user_name || (self.userRoles !== null && _.indexOf(self.userRoles, 'ES_PM') > -1))) {
          //console.log(data.item.gtc_owner);
          return true;
        }

        else if (self.userFunctions == null || self.userFunctions == [] || self.userSites == null || self.userSites == []) {
          return false;
        }

        // CASE 6 - Function include 'ESPM Leader' -> Enable link for all
        else if (self.userFunctions !== null && self.userFunctions.includes("ES PM Leader")
          && signing_stage.status_name !== null) {
          return true;
        }

        // CASE 5 - Function include 'GRO TOP Manager' -> Enable link for all except ESPM related (e.g. Rowina)
        else if (self.userFunctions !== null && self.userFunctions.includes("GRO TOP Manager")
          && _.indexOf(['ES PM', 'ES PM Leader', 'Estimation ESPM Kickoff'], signing_stage.stage_name) == -1
          && signing_stage.status_name !== null) {
          console.log("userFunctions.includes('GRO TOP Manager')");
          console.log(self.userFunctions.includes("GRO TOP Manager"));
          return true;
        }

        // CASE 4 - Function include 'GRO Manager' -> Enable link for SA Head Review/Confirm, RSM, Sales Dir, GRO Head Confirmation
        else if (self.userFunctions !== null && self.userFunctions.includes("GRO Manager")
          && _.indexOf(stages_for_gro_manager, signing_stage.stage_name) > -1
          && signing_stage.status_name !== null
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)) {
          console.log("userFunctions.includes('GRO Manager')");
          console.log(self.userFunctions.includes("GRO Manager"));
          return true;
        }

        // CASE 3 - Function include 'Getac Sales Manager' -> Enable link for HQ Sales Review/Confirm
        else if (self.userFunctions !== null && self.userFunctions.includes("Getac Sales Manager")
          //&& (signing_stage.stage_name == 'HQ Sales Review' || signing_stage.stage_name == 'GTC Sales Conformation')
          && _.indexOf(stages_for_getac_sales_manager, signing_stage.stage_name) > -1
          && signing_stage.status_name !== null
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)) {
          console.log("userFunctions.includes('Getac Sales Manager')");
          console.log(self.userFunctions.includes("Getac Sales Manager"));
          return true;
        }

        // CASE 2 - Function include 'GRO RSM Manager' -> Enable link for RSM, Sales Dir
        else if (self.userFunctions !== null && self.userFunctions.includes("GRO RSM Manager")
          //&& (signing_stage.stage_name == 'GRO RSM Review' || signing_stage.stage_name == 'GRO Sales Director' || signing_stage.stage_name == 'GRO GM Confirmation')
          && _.indexOf(stages_for_rsm_manager, signing_stage.stage_name) > -1
          && signing_stage.status_name !== null
          && (data.item.nre_site !== null && _.indexOf(self.userSites, data.item.nre_site) > -1)) {
          console.log("userFunctions.includes('GRO RSM Manager')");
          console.log(self.userFunctions.includes("GRO RSM Manager"));
          if (self.userFunctions.includes("Getac Sales Manager")) {
            // roles like dennis, also belogn to Sales Manager
            return true;
          }
          else {
            if (data.item.participant_names !== null && Object.values(data.item.participant_names).includes(login_user_name)) {
              // roles like dennis, also belogn to Sales Manager
              // need to participate in this flow then can view those RSM, Sales Director Stages
              return true;
            }
          }
        }
        else {
          return false;
        }
      },
      adminMemberSettingAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1)
        ) {
          return true
        }
        return false;
      },

      getLink(data, stage_index) {
        let self = this;
        var nre = data.item;
        var signing_stage = nre.signing_stages[stage_index];
        var url = '/' + self.urlHead[stage_index];

        if (stage_index === 0 && _.get(signing_stage, 'status_name', null) === 'Submitted') {
          console.log("stage_index:" + stage_index);
          console.log("completed:" + _.get(signing_stage, 'status_name', null));
          var url = '/' + self.urlHead[stage_index] + '-and-review'; // espm-submitted-and-review
        } else {
          var url = '/' + self.urlHead[stage_index];
        }
        url += '/' + encodeURIComponent(nre.ftie_ticket.ftie_id);
        url += '/' + encodeURIComponent(nre.sku_id);
        url += '/' + encodeURIComponent(nre.nre_id);
        url += '/' + encodeURIComponent(nre.real_sku_no);
        url += '/' + encodeURIComponent(signing_stage.submitted_by.submitter_name);
        //url += '/' + encodeURIComponent(nre.account);
        return url;
      },

      tooltipTitle(data, stage_index) {
        let self = this;
        var signing_stage = data.item.signing_stages[stage_index];
        return _.trim(self.stageTip[stage_index] + ' ' + _.trim(_.get(signing_stage, 'status_name', '')))
      },

      tooltipReason(data) {
        let self = this;
        return _.trim(_.get(data.item, 'reject_reason', ''))
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;

        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);

        this.GTC_owner = options.gtc_owner_default;
        this.GRO_owner = options.gro_owner_default;

        console.log("GTCOwnerList:");
        console.log(this.GTCOwnerList);
        console.log("GROOwnerList:");
        console.log(this.GROOwnerList);

        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var gro_option_new = new Array();
        for (i = 0; i < options.gro_opt_val_list.length; i++) {
          gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        }
        this.GRO_options = gro_option_new;
        this.GRO_options_default = gro_option_new[0];
        this.GRO = gro_option_new[0].value;
        this.GROText = gro_option_new[0].text;
        let indexStr = this.GROText + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        var nre_status_options_new = new Array();
        for (i = 0; i < options.nre_status_opt_val_list.length; i++) {
          nre_status_options_new.push({ value: options.nre_status_opt_val_list[i], text: options.nre_status_opt_text_list[i] })
        }
        this.NRE_status_options = this.NRE_status_options.concat(nre_status_options_new);
        this.NRE_status = this.NRE_status_options;

      },
      onChangeGRO(GRO) {
        let groText = GRO;
        if('' === GRO){
          groText = 'ALL';
        }
        var options = this.$session.get('options');
        let indexStr = GRO + "." + 'GRO_owners';
        this.GROOwnerList = _.get(this.ownerSelectionDic, indexStr, options.gro_owner_opt_list);
        //this.GROOwnerList = this.ownerSelectionDic[GRO]['GRO_owners'];
      },

      onChange(my_status) {
        if (my_status.length > 0) {
          this.pageLimit = 1;
          this.pageDisabled = true;
        }
        else {
          this.pageLimit = 10;
          this.pageDisabled = false;
          this.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        }
        if (my_status.length == 1) {
          if (my_status[0].text.indexOf('Completed') >= 0) {
            this.NRE_status = [{ value: 'Completed', text: 'Completed' }, { value: 'Deferred', text: 'Deffered' }, { value: 'Rejected', text: 'Rejected' }]; //{Completed, Deffered, Rejected}
            this.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
          }
          else {
            this.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];
            this.ticket_status = [{ value: 'Open', text: 'Open' }];
          }
        }
        else if (my_status.length > 1) {
          let my_status_contents = my_status.map(({ text }) => text);
          this.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
          let nre_status_contents = this.NRE_status.map(({ text }) => text);
          let ticket_status_contents = this.ticket_status.map(({ text }) => text);

          let nre_options_completed_related = ['Completed', 'Deffered', 'Rejected'];
          let nre_options_completed_related_value = ['Completed', 'Deffered', 'Rejected'];

          let ticket_options_completed_related = ['Solved', 'Closed', 'Deferred'];
          let ticket_options_completed_related_value = ['Solved', 'Close', 'Deferred'];

          let nre_options_in_progress = ['Ongoing', 'Awaiting'];
          let nre_options_in_progress_value = ['Waiting', 'W'];

          // If my_status not include 'Completed' -> remove completed replated status --NRE_status = {Completed, Deffered, Rejected}, --ticket_status = {Solved, Closed, Deferred }
          if (my_status_contents.indexOf('Completed') < 0) {
            // -- update this.NRE_status
            var i;
            for (i = 0; i < nre_options_completed_related.length; i++) {
              const index_remove_nre_status = nre_status_contents.indexOf(nre_options_completed_related[i]);
              if (index_remove_nre_status > -1) {
                this.NRE_status.splice(index_remove_nre_status, 1);
              }
            }

            // -- update this.ticket_status
            for (i = 0; i < ticket_options_completed_related.length; i++) {
              const index_remove_ticket_status = ticket_status_contents.indexOf(ticket_options_completed_related[i]);
              if (index_remove_ticket_status > -1) {
                this.ticket_status.splice(index_remove_ticket_status, 1);
              }
            }
          } else {
            // my_status include 'Completed'
            // -- update this.NRE_status
            var i;
            for (i = 0; i < nre_options_completed_related.length; i++) {
              const index_remove_nre_status = nre_status_contents.indexOf(nre_options_completed_related[i]);
              // if related nre_status not in this.nre_status, add them
              if (index_remove_nre_status < 0) {
                this.NRE_status.push({ value: nre_options_completed_related_value[i], text: nre_options_completed_related[i] });
              }
            }
            // -- update this.ticket_status
            for (i = 0; i < ticket_options_completed_related.length; i++) {
              const index_remove_ticket_status = ticket_status_contents.indexOf(ticket_options_completed_related[i]);
              // if related ticket_status not in this.ticket_status, add them
              if (index_remove_ticket_status < 0) {
                this.ticket_status.push({ value: ticket_options_completed_related_value[i], text: ticket_options_completed_related[i] });
              }
            }

          }
          // if my_status not include 'In Progress' and not incalude 'Oncoming' -> remove --NRE_status = { Ongoing, Awaiting },
          if (my_status_contents.indexOf('In Progress') < 0 && my_status_contents.indexOf('Oncoming') < 0) {
            // -- update this.NRE_status
            var i;
            for (i = 0; i < nre_options_in_progress.length; i++) {
              const index_remove_nre_status = nre_status_contents.indexOf(nre_options_in_progress[i]);
              if (index_remove_nre_status > -1) {
                this.NRE_status.splice(index_remove_nre_status, 1);
              }
            }
          }
          else {
            // -- update this.NRE_status
            var i;
            for (i = 0; i < nre_options_in_progress.length; i++) {
              const index_remove_nre_status = nre_status_contents.indexOf(nre_options_in_progress[i]);
              // if related nre_status not in this.nre_status, add them
              if (index_remove_nre_status < 0) {
                this.NRE_status.push({ value: nre_options_in_progress_value[i], text: nre_options_in_progress[i] });
              }
            }
          }
        }
      },
      search() {
        if (this.etoLoadingCnt == 0) {
          this.already_first_search_flag = false;
          this.etoLoadingCnt = this.etoLoadingCnt + 1;
        }
        this.currentPage = 1;
        this.getNres();
      },
      pageChange(page) {
        this.currentPage = page
        this.getNres() // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.getNres() // api call
      },
      getNres() {
        let self = this;
        let url = self.$root.baseUrl + '/nre/';
        console.log('####getNres######');
        var model_selected = [];
        var nre_status_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.NRE_status.length == 0) {
          nre_status_selected.push("")
        } else {
          for (i = 0; i < self.NRE_status.length; i++) {
            nre_status_selected.push(self.NRE_status[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.my_status.length == 0) {
          my_status_selected = ['']
        }
        else {
          for (i = 0; i < self.my_status.length; i++) {
            my_status_selected.push(self.my_status[i]['value'])
          }
        }

        let request_data = {
          model_selected: model_selected,
          nre_status_selected: nre_status_selected,
          ticket_status_selected: ticket_status_selected,
          my_status_selected: my_status_selected,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          search_by_nre_id: self.serachByNreId,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let nreTotalCount = 0;
        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['nre_info_object']);
              nreTotalCount = parseInt(searchedData[0].total_count);
              //console.log(searchedData);
              //console.log('ftie_ticket::');
              //console.log(searchedData[0].ftie_ticket);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.nreTotalCount = nreTotalCount;
          })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.my_status = [];
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
        self.my_status = [];
        if (self.serachByNreId !== null) {
          self.serachByNreId = null;
          self.$router.push('/dashboard');
        }
        self.serachByNreId = null;
      },
      focusButton() {
        // 重新聚焦按鈕
        setTimeout(() => {
          this.$refs.focusButton.focus();
        }, 100);
      },
      preConfirm(nre, flag) {
        let self = this;
        self.confirmNre = { ftie_id: nre.ftie_ticket.ftie_id, nre_id: nre.nre_id, request_form_id: nre.request_form_id, confirm_flag: flag };
        self.$refs['preConfirmModal'].show();
      },
      confirmTracking(ftie_id, nre_id, request_form_id, confirm_flag) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/confirm-tracking-log/';

        let request_data = {
          ftie_id: self.confirmNre.ftie_id,
          nre_id: self.confirmNre.nre_id,
          request_form_id: self.confirmNre.request_form_id,
          confirm_flag: self.confirmNre.confirm_flag,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        //self.searching = true;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            //console.log(resRead);
            if (_.get(response, 'status', 0) !== 200) return;
            let data = response.data;
            if (response.save_success) {
              self.$message.info('confirm-nre success!')
            } else {
              self.$message.error(_.get(resRead, 'description', "confirm-nre error"), 'Error');
            }

          })
          .finally(() => {

            self.$nextTick(() => {
              self.$refs['preConfirmModal'].hide();
              self.confirmNre = { ftie_id: '', nre_id: '', request_form_id: '', confirm_flag: '' };
              self.getNres();
            });
            eventHub.$emit('loading', false);
          });
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ETODashboard.vue